module.exports = __webpack_public_path__ + "assets/media/star_req.bc2a183e.svg";